import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';

class Lesson {
    constructor() {
        this.isInit = false;
        this.sliderBeforeAfterInstance = null;
    }

    init() {
        if (!this.isInit) {
            this.sliderBeforeAfter = document.getElementById('sliderBeforeAfter');
            this.sliderSwitchers = document.querySelectorAll('[data-swiper-switcher]');

            this.onHandlerSliderSwitcherClick = this.handlerSliderSwitcherClick.bind(this);

            this.isInit = true;
            this.bind();
            
        }
    }

    destroy() {
        if (this.isInit) {
            this.isInit = false;
            this.unbind();
        }
    }

    bind() {
        if (this.sliderBeforeAfter) {
            this.sliderBeforeAfterInstance = new Swiper(this.sliderBeforeAfter, {
                allowTouchMove: false
            });

            this.sliderSwitchers.forEach(el => {
                el.addEventListener('click', this.onHandlerSliderSwitcherClick);
            });
        }
    }

    unbind() {
        if (this.sliderBeforeAfter) {
            this.sliderBeforeAfterInstance.destroy();
            this.sliderBeforeAfterInstance = null;

            this.sliderSwitchers.forEach(el => {
                el.removeEventListener('click', this.onHandlerSliderSwitcherClick);
            });
        }
    }

    handlerSliderSwitcherClick(e) {
        e.preventDefault();
        this.sliderSwitchers.forEach(el => {
            if (el === e.target) {
                el.classList.add('active');
            } else {
                el.classList.remove('active');
            }
        });
        this.sliderBeforeAfterInstance.slideTo(Number(e.target.dataset.swiperSwitcher), 300, true);
    }
}

export default Lesson;